

<header>
  <div class="container">
  </div>
</header>

<div *ngIf="model && !report" class="padding20 white-bg">
  <a (click)="submitTemplate()" class="float">
    <i class="fas fa-save my-float"></i>
  </a>
  <div class="spacer30"></div>
  <div class="row">
    <div class="col-3">
      <!--a draggable element-->
      <h4 style="margin-top: 1%; font-size: 22px;">Seleccione los campos</h4>
      <p>Diseñe su plantilla arrastrando y soltando los campos al area de la plantilla.</p>
      <div class="sticky-container" style="margin-top:-1%">
        <ul class="sticky">
          <div class="fields" *ngFor="let item of fieldModels">
            <div class="field pointer shadow-bg" style="height: 30px; width: 170px;" [dndDraggable]="item" [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)">
              <div class="row">
                <i [ngClass]="item.icon" class="fa pull-left"></i>
                <h5 style="margin-left: 15px;">{{item.label}}</h5>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>
    <div class="col-8">
      <h1>Diseño plantilla</h1>
      <div class="form-group" style="margin-bottom: 0px !important; padding: 30px 60px 5px 60px;">
        <h2><input class="form-control" type="text" [(ngModel)]="model.name" /></h2>
        <input class="form-control" type="text" [(ngModel)]="model.description" />
      </div>
  
      <!--a dropzone-->
      <!--to allow dropping content that is not [dndDraggable] set dndAllowExternal to true-->
      <section dndDropzone
      (dndDragover)="onDragover($event)"
      (dndDrop)="onDrop($event,model.attributes)" class="dndDropArea"
      [ngClass]="{'empty':model.attributes.length == 0}"> 
        
        <div class="field" *ngFor="let item of model.attributes;let i= index;" 
          (dndStart)="onDragStart($event)"
          (dndCanceled)="onDragCanceled($event)"
          (dndMoved)="onDragged(item, model.attributes, 'move')"
          [dndEffectAllowed]="'all'" 
          [dndDraggable]="item">
            <div class="row form-group">
              <div class="col-1"><i class="fa fa-ellipsis-v dndHandle" dndHandle></i></div>
              <div class="col-7">
                <div *ngIf="item.type=='text'">
                  <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
                  <input type="text" class="form-control" id="{{item.name}}" placeholder="{{item.placeholder}}" >
                </div>
                <div *ngIf="item.type=='email'">
                  <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
                  <input type="email" class="form-control" id="{{item.name}}" placeholder="{{item.placeholder}}" >
                </div>
                <div *ngIf="item.type=='phone'">
                  <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
                  <input type="text" class="form-control" id="{{item.name}}" placeholder="{{item.placeholder}}" >
                </div>
                <div *ngIf="item.type=='number'">
                  <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
                  <input type="number" class="form-control" id="{{item.name}}" min="{{item.min}}" max="{{item.max}}" placeholder="{{item.placeholder}}" >
                </div>
                <div *ngIf="item.type=='date'">
                  <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
                  <input type="date" class="form-control" id="{{item.name}}" placeholder="{{item.placeholder}}" >
                </div>
                <div *ngIf="item.type=='datetime-local'">
                  <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
                  <input type="datetime-local" class="form-control" id="{{item.name}}" placeholder="{{item.placeholder}}" >
                </div>
                <div *ngIf="item.type=='textarea'">
                  <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
                  <textarea class="form-control" id="{{item.name}}" placeholder="{{item.placeholder}}" ></textarea>
                </div>
                <div *ngIf="item.type=='paragraph'">
                  <p class="form-text">{{item.placeholder}}</p>
                </div>
                <div *ngIf="item.type=='autocomplete'">
                  <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
                  <select class="form-control" id="{{item.name}}" >
                    <option *ngFor="let v of item.values" [value]="v.value">{{v.label}}</option>  
                  </select> 
                </div>
                <div *ngIf="item.type=='checkbox'">
                  <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
                  <div *ngFor="let v of item.values" class="inline-form-group">
                    <label class="cust-check-bx">
                      <input type="checkbox" [value]="v.value" name="{{item.name}}" (click)="toggleValue(v)"> {{v.label}}
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
                <div *ngIf="item.type=='radio'">
                  <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
                  <div *ngFor="let v of item.values" class="inline-form-group">
                    <label class="cust-check-bx">
                      <input type="radio" [value]="v.value" name="{{item.name}}" > {{v.label}}
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
                <div *ngIf="item.type=='button'" class="btn-cont">
                  <input type="{{item.subtype}}" (click)="submit()" value="{{item.label}}" class="btn btn-primary" id="{{item.name}}" >
                </div>
              </div>
              <div class="col-4">
                <i *ngIf="item.toggle" (click)="item.toggle=false" class="fa fa-chevron-up pull-right"></i>
                <i *ngIf="!item.toggle" (click)="item.toggle=true" class="fa fa-chevron-down pull-right"></i>
                <i (click)="removeField(i)" class="fa fa-trash pull-right"></i>
              </div>
            </div>
            <div *ngIf="item.toggle" class="toggle-Wrapper">
              <div class="form-group">
                <label>Requerido</label>
                <i *ngIf="item.required" (click)="item.required=false" class="fa fa-toggle-on red"></i>
                <i *ngIf="!item.required" (click)="item.required=true" class="fa fa-toggle-off"></i>
                <span class="pull-right ucfirst">{{item.type}}</span>
              </div>
              <div class="form-group">
                <label>Label</label>
                <input class="form-control" type="text" [(ngModel)]="item.label" />
              </div>
              <div class="form-group">
                <label>Nombre</label>
                <input class="form-control" type="text" [(ngModel)]="item.name" />
              </div>
              <div class="form-group">
                <label>Contenedor</label>
                <input class="form-control" type="text" [(ngModel)]="item.placeholder" />
              </div>
              <div class="form-group">
                <label>Expresiones regulares (Regex)</label>
                <input class="form-control" type="text" [(ngModel)]="item.regex" />
              </div>
              <div *ngIf="item.regex" class="form-group">
                <label>Error del texto</label>
                <input class="form-control" type="text" [(ngModel)]="item.errorText" />
              </div>
            <!-- number -->
              <div *ngIf="item.type=='number'" class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label>Minimo</label>
                    <input class="form-control" type="text" [(ngModel)]="item.min" />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label>Maximo</label>
                    <input class="form-control" type="text" [(ngModel)]="item.max" />
                  </div>
                </div>
              </div>
            <!-- radio || checkbox || autocomplete -->
              <div *ngIf="item.type=='radio'|| item.type=='checkbox' || item.type=='autocomplete'" >
                <div class="row">
                  <div class="col-5">
                    <div class="form-group">
                      <label>Label</label>
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="form-group">
                      <label>Valor</label>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="form-group">
                      <label>Accion</label>
                    </div>
                  </div>
                </div>
                <div *ngFor="let i of item.values; let valueIndex=index;" class="row">
                  <div class="col-5">
                    <div class="form-group">
                      <input class="form-control" type="text" [(ngModel)]="i.label" />
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="form-group">
                      <input class="form-control" type="text" [(ngModel)]="i.value" />
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="form-group">
                      <label (click)="item.values.splice(valueIndex,1)">Eliminar</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5">
                    <div class="form-group">
                      <input class="form-control" type="text" [(ngModel)]="value.label" />
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="form-group">
                      <input class="form-control" type="text" [(ngModel)]="value.value" />
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="form-group">
                      <label (click)="addValue(item.values)">Agregar</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</div>
<div *ngIf="model" class="container marginT60  marginB30" style="max-width:500px;">
  <div class="row" style="padding:30px;">
    <div class="col-12">
      <h1 style="margin-bottom: 20px;">Vista previa</h1>
      <h2>{{model.name}}</h2>  
    </div>
    <div class="col-12">
      <p>{{model.description}}</p>  
    </div>
  </div>
  <form class="ftheme" >
    <div *ngIf="!success" class="col-12">
      <div *ngFor="let item of model.attributes" class="form-group">
        <div *ngIf="item.type=='text'">
          <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
          <input type="text" class="form-control" id="{{item.name}}" placeholder="{{item.placeholder}}" [(ngModel)]="item.value" [required]="item.required" [ngModelOptions]="{standalone: true}" autocomplete="off">
        </div>
        <div *ngIf="item.type=='email'">
          <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
          <input type="email" class="form-control" id="{{item.name}}" placeholder="{{item.placeholder}}" [(ngModel)]="item.value" [ngModelOptions]="{standalone: true}" autocomplete="off">
        </div>
        <div *ngIf="item.type=='phone'">
          <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
          <input type="email" class="form-control" id="{{item.name}}" placeholder="{{item.placeholder}}" [(ngModel)]="item.value" [ngModelOptions]="{standalone: true}" autocomplete="off">
        </div>
        <div *ngIf="item.type=='number'">
          <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
          <input type="number" class="form-control" id="{{item.name}}" min="{{item.min}}" max="{{item.max}}" placeholder="{{item.placeholder}}" [(ngModel)]="item.value" [ngModelOptions]="{standalone: true}" autocomplete="off">
        </div>
        <div *ngIf="item.type=='date'">
          <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
          <input type="date" class="form-control" id="{{item.name}}" placeholder="{{item.placeholder}}" [(ngModel)]="item.value" [ngModelOptions]="{standalone: true}" autocomplete="off">
        </div>
        <div *ngIf="item.type=='datetime-local'">
          <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
          <input type="datetime-local" class="form-control" id="{{item.name}}" placeholder="{{item.placeholder}}" [(ngModel)]="item.value" [ngModelOptions]="{standalone: true}" autocomplete="off">
        </div>
        <div *ngIf="item.type=='textarea'">
          <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
          <textarea class="form-control" id="{{item.name}}" placeholder="{{item.placeholder}}" [(ngModel)]="item.value" [ngModelOptions]="{standalone: true}" autocomplete="off"></textarea>
        </div>
        <div *ngIf="item.type=='paragraph'">
          <p class="form-text">{{item.placeholder}}</p>
        </div>
        <div *ngIf="item.type=='autocomplete'">
          <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
          <select class="form-control" id="{{item.name}}" [(ngModel)]="item.value" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let v of item.values" [value]="v.value">{{v.label}}</option>  
          </select>
        </div>
        <div *ngIf="item.type=='checkbox'">
          <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
          <div *ngFor="let v of item.values" class="inline-form-group">
            <label class="cust-check-bx">
              <input type="checkbox" [value]="v.value" name="{{item.name}}" (click)="toggleValue(v)"> {{v.label}}
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
        <div *ngIf="item.type=='radio'">
          <label>{{item.label}}</label> <label *ngIf="item.required" class="text-danger">*</label>
          <div *ngFor="let v of item.values" class="inline-form-group">
            <label class="cust-check-bx">
              <input type="radio" [value]="v.value" name="{{item.name}}" [(ngModel)]="item.value" [ngModelOptions]="{standalone: true}"> {{v.label}}
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
        <div *ngIf="item.type=='button'" class="btn-cont">
          <input type="{{item.subtype}}" (click)="submit()" value="{{item.label}}" class="btn btn-primary" id="{{item.name}}" >
        </div>
      </div>  
    </div>
  </form>
</div>